import { useLazyQuery } from '@apollo/client';
import {
  Badge,
  Box,
  Button,
  Flex,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import React from 'react';
import { Link } from 'react-router-dom';
import HeaderWithActions from '../../components/HeaderWithActions';
import ListView from '../../components/ListView';
import Meta from '../../components/Meta';
import { useSchemaQuery } from '../../react-apollo-introspection';

import { DELETE, FETCH_ALL } from './graphql';
import { setup } from './setup';

const columns = [
  {
    Header: '',
    accessor: '_id',
    disableSortBy: true,
    Cell: ({ row }) => (
      <Link to={`/${setup.model}/edit/${row.original[setup.accessor]}`}>
        <Button variant='link'>View</Button>
      </Link>
    ),
  },
  {
    Header: 'Title',
    accessor: 'title',
    disableSortBy: false,
    Cell: ({ value }) => <div>{value}</div>,
  },

  {
    Header: 'Category',
    accessor: 'categories',
    disableSortBy: false,
    Cell: ({ value }) => {
      return (
        <Flex gap={5}>
          {value?.eat && (
            <Text
              fontWeight='bold'
              bg='#b52828'
              px='10px'
              py='0.1em'
              color='white'
              borderRadius='50px'
            >
              Eat
            </Text>
          )}
          {value?.sleep && (
            <Text
              fontWeight='bold'
              bg='#749079'
              px='10px'
              py='0.1em'
              color='white'
              borderRadius='50px'
            >
              Sleep
            </Text>
          )}
          {value?.drink && (
            <Text
              fontWeight='bold'
              bg='#6d2db7'
              px='10px'
              py='0.1em'
              color='white'
              borderRadius='50px'
            >
              Drink
            </Text>
          )}
          {value?.daysOut && (
            <Text
              fontWeight='bold'
              bg='#F4A259'
              px='10px'
              py='0.1em'
              color='white'
              borderRadius='50px'
            >
              Days Out
            </Text>
          )}
          {value?.experience && (
            <Text
              fontWeight='bold'
              bg='#3B8EA5'
              px='10px'
              py='0.1em'
              color='white'
              borderRadius='50px'
            >
              Experience
            </Text>
          )}
        </Flex>
      );
    },
  },
];

const filters = [
  {
    value: 'last_name',
    type: 'text',
    label: 'Last Name',
    isOperator: false,
  },
];

const List = ({ title }) => {
  const [fetchData, { loading, error, data }] = useSchemaQuery(FETCH_ALL);

  return (
    <Meta title={setup.title}>
      <HeaderWithActions title={setup.title}>
        <Stack ml='auto' isInline spacing='15px'>
          {setup.canAddNew && (
            <Link to={`/${setup.model}/create`}>
              <Button>Add {setup.singular}</Button>
            </Link>
          )}
        </Stack>
      </HeaderWithActions>
      <Box
        mt='25px'
        bg={useColorModeValue('white', 'gray.700')}
        shadow='base'
        rounded={{
          base: 'md',
          sm: 'xl',
        }}
        w='100%'
      >
        <ListView
          setup={setup}
          fetchData={fetchData}
          data={data?.[FETCH_ALL]}
          loading={loading}
          error={error}
          gqlDelete={DELETE}
          columns={columns}
          filters={filters}
        />
      </Box>
    </Meta>
  );
};

export default List;
